import React from 'react';
import Select from "react-select";


const FreightTabAirlineTariff = () => {
    return (
        <div className="container border p-3">
            {/* Header Section */}
            <div className="row mb-3">
                <div className="col-md-6 d-flex align-items-center">
                    <label className="form-check-label me-2">
                        <input type="radio" name="rateType" className="form-check-input" /> Flat Rate
                    </label>
                    <label className="form-check-label">
                        <input type="radio" name="rateType" className="form-check-input" /> Slab Rate
                    </label>
                </div>
                {/* <div className="col-md-6 text-start">
                    <label className="form-check-label me-2">
                        <input type="checkbox" name="companyTariff" className="form-check-input" /> Company Tariff (Freight)
                    </label>
                    <div className="d-flex">
                        <label className="me-2">Markup</label>
                        <div className="icon-forms mb-3 mb-sm-0 w-50">
                                            <Select className='custom-selector w-100' name="role_id" />
                                        </div>
                                        <input type="number" className="form-control form-control-sm ms-2 w-50" name='search_by'placeholder='0.000' />

                    </div>
                </div> */}
            </div>

            {/* Freight Table */}
            <div className="row">
                <div className="col-md-6">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Slab</th>
                                <th>Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Freight Rate Normal</td>
                                <td><input type="text" className="form-control form-control-sm" /></td>
                            </tr>
                            {["+45.00 KGS", "+100.00 KGS", "+250.00 KGS", "+300.00 KGS", "+1000.00 KGS", "+5000.00 KGS"].map((slab, index) => (
                                <tr key={index}>
                                    <td>{slab}</td>
                                    <td><input type="text" className="form-control form-control-sm" /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                
            </div>
        </div>
    );
};

export default FreightTabAirlineTariff;
